import AppRoutes from './routes/Routes';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { AuthProvider } from './contexts/AuthContext';

function App() {
  ModuleRegistry.registerModules([AllCommunityModule]);

  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

export default App;